import React, { useState, useEffect } from 'react';
import {
    Container,
    Paper,
    Typography,
    Box,
    Divider,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    ListItemButton,
    Tabs,
    Tab
} from '@mui/material';
import {
    Person as PersonIcon,
    Email as EmailIcon,
    Security as SecurityIcon,
    Logout as LogoutIcon,
    People as PeopleIcon
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from '../config';
import UserManagement from '../components/UserManagement';

const Profile = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [activeTab, setActiveTab] = useState(0);

    useEffect(() => {
        const userData = localStorage.getItem('user');
        if (userData) {
            setUser(JSON.parse(userData));
        } else {
            navigate('/login');
        }
    }, [navigate]);

    const handleLogout = async () => {
        try {
            await axios.post(`${API_BASE_URL}/auth/logout.php`);
            localStorage.removeItem('user');
            window.location.href = '/login';
        } catch (err) {
            console.error('Logout error:', err);
        }
    };

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    if (!user) {
        return null;
    }

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 4 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h4" gutterBottom>
                    Profile Settings
                </Typography>
                <Divider sx={{ mb: 3 }} />

                <Tabs
                    value={activeTab}
                    onChange={handleTabChange}
                    sx={{ mb: 3 }}
                >
                    <Tab label="Profile" icon={<PersonIcon />} iconPosition="start" />
                    {user.role === 'admin' && (
                        <Tab label="User Management" icon={<PeopleIcon />} iconPosition="start" />
                    )}
                </Tabs>

                {activeTab === 0 && (
                    <Box sx={{ display: 'flex', gap: 4 }}>
                        <Box sx={{ flex: 1 }}>
                            <List>
                                <ListItem>
                                    <ListItemIcon>
                                        <PersonIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Username"
                                        secondary={user.username}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <EmailIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Email"
                                        secondary={user.email}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemIcon>
                                        <SecurityIcon />
                                    </ListItemIcon>
                                    <ListItemText
                                        primary="Role"
                                        secondary={user.role}
                                    />
                                </ListItem>
                                <ListItem>
                                    <ListItemButton onClick={handleLogout}>
                                        <ListItemIcon>
                                            <LogoutIcon color="error" />
                                        </ListItemIcon>
                                        <ListItemText
                                            primary="Logout"
                                            primaryTypographyProps={{ color: 'error' }}
                                        />
                                    </ListItemButton>
                                </ListItem>
                            </List>
                        </Box>
                    </Box>
                )}

                {activeTab === 1 && user.role === 'admin' && (
                    <UserManagement />
                )}
            </Paper>
        </Container>
    );
};

export default Profile;